import axios from "axios";
import * as Constants from "../api/constants";
import { deepMerge, loadMergedCms, saveFullCms } from "./cmsStorage";
import { buildDefaultSiteCms } from "../cms/defaultSiteContent";

/** True when persisted file has at least one top-level CMS section with content. */
function isNonEmptyCmsBlob(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return false;
  return ["home", "booking", "bookingForm", "decorations", "theaterMedia"].some(
    (k) => {
      const v = obj[k];
      return v != null && typeof v === "object" && Object.keys(v).length > 0;
    }
  );
}

/**
 * Returns remote CMS merged onto code defaults when the backend file holds data; otherwise null
 * so the shell can keep localStorage as-is for offline/low-config dev.
 */
export async function pullSiteCmsFromServer(signal) {
  try {
    const res = await axios.get(Constants.PUBLIC_SITE_CMS_URL, {
      timeout: 20000,
      signal,
    });
    const data = res?.data;
    if (!isNonEmptyCmsBlob(data)) {
      return null;
    }
    return deepMerge(buildDefaultSiteCms(), data);
  } catch (_) {
    return null;
  }
}

export function hydrateCmsIntoStorage(remoteMerged) {
  saveFullCms(remoteMerged);
  return remoteMerged;
}

/** SUPER_ADMIN write of full merged CMS blob to server's {@code partyboss.site-cms.file}. */
export async function pushSiteCmsToServer(fullCmsPayload, adminRole) {
  await axios.put(Constants.ADMIN_SITE_CMS_URL, fullCmsPayload, {
    headers: {
      "Content-Type": "application/json",
      "X-Admin-Role": adminRole ? String(adminRole).trim().toUpperCase() : "",
    },
  });
}

/** Force browser store to defaults + disk snapshot (explicit admin click). */
export async function reloadSiteCmsFromServerClick() {
  const remote = await pullSiteCmsFromServer();
  if (remote != null) {
    return hydrateCmsIntoStorage(remote);
  }
  return loadMergedCms();
}
